import React, { useState } from "react";
import { Container, Row, Col, Alert, Button } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import WithProducts from "../../HOC/HOCProducts";
import ProductCard from "../Product/ProductCard";

const Category = ({ products, handleDelete, handleAddToCart, categoryData, handlePagination, keywords, page, pages }) => {
  const { category } = useParams();
  if (process.env.NODE_ENV === "development") {
    console.log("category", category);
  }

  const [listPagination, setListPagination] = useState(keywords);
  const [count, setCount] = useState(1);
  if (process.env.NODE_ENV === "development") {
    console.log("state", listPagination, count, page, pages);
  }

  const handleNext = (e) => {
    e.preventDefault();
    const updated = { ...listPagination, page: listPagination.page + 1, limit: listPagination.limit };
    if (process.env.NODE_ENV === "development") {
      console.log("updated nn", updated);
    }
    setListPagination(updated);
    handlePagination(updated);
    setCount((count) => count + 1);
  };

  const handlePrev = (e) => {
    e.preventDefault();
    const updated = { ...listPagination, page: listPagination.page - 1, limit: listPagination.limit };
    if (process.env.NODE_ENV === "development") {
      console.log("updated pp", updated);
    }
    setListPagination(updated);
    handlePagination(updated);
    setCount((count) => count - 1);
  };

  if (!Array.isArray(categoryData) || categoryData.length === 0) {
    return (
      <Alert variant="info" className="text-center">
        No products available. <br />
        <span className="fw-bold">Check back later or contact support.</span>
      </Alert>
    );
  }

  return (
    <Container>
      <Row>
        <Container>
          <Col lg={12}>
            <h1 className="text-center hover-underline">Category</h1>
          </Col>
        </Container>
      </Row>
      <Row className="row-xs-no-padding">
        {categoryData && categoryData.map((product) => (
          <Col key={product._id} lg={3} md={6} sm={6} xs={6} className="mb-3">
            <ProductCard
              product={product}
              handleDelete={handleDelete}
              handleAddToCart={handleAddToCart} />
          </Col>
        ))}
      </Row>
      {/* <Row className="my-3 text-center">
        <Col lg={12}>
          <Button onClick={handlePrev} className="me-2" disabled={page === 1}>Prev</Button>
          <Button onClick={handleNext} >Next</Button>
        </Col>
        <Col lg={12}>
          Page {page} of {pages}
        </Col>
      </Row> */}
      <Row>
        <Col lg={12}>
          <p className="text-center">Thanks for visiting our website!</p>
        </Col>
      </Row>
    </Container>
  );
};

export default WithProducts(Category);
